module.exports = __webpack_public_path__ + "static/media/hull_color_style_0006.8562b424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0006.jpg
// module id = 624
// module chunks = 0